function PgMigrationStatus() {
    return {
        restrict: 'E',
        scope: {
            status: '=status'
        },
        templateUrl: '/partials/controls/PaymentGateway/pg-migration-status.html'
    };
}
